module.exports = __webpack_public_path__ + "static/assets/632b19066ba7aab0c95b135555dfa8d4.svg";